import styles from './finance-offers-carousel.module.css'
import React, { useMemo } from 'react'
import { Text } from '@cinch-labs/design-system'
import { SoldByPartnerInfo } from '@cinch-nx/ui-new-cars-drawer'
import {
  Carousel,
  CarouselControls,
  CarouselNavigation,
  CarouselPagination,
  CarouselSlide,
} from '@cinch-labs/design-system'

export interface FinanceOffersCarouselProps {
  title: string
  description: string
  disclaimer: string
  cards: React.ReactNode[]
}

export function FinanceOffersCarousel({
  title,
  description,
  disclaimer,
  cards,
}: FinanceOffersCarouselProps) {
  const carouselId = useMemo(
    () => 'carousel-' + Math.random().toString(36).slice(2, 15),
    [],
  )

  return (
    <section className={styles.container}>
      <div className={styles.header}>
        {title && <Text className={styles.title}>{title}</Text>}
        {description && (
          <Text className={styles.description}>{description}</Text>
        )}
        {disclaimer && (
          <div className={styles.disclaimerContainer}>
            <SoldByPartnerInfo
              callToActionClassName={styles.disclaimer}
              callToActionText={disclaimer}
            />
          </div>
        )}
      </div>
      <Carousel
        name={carouselId}
        customClassNames={{ carousel: styles.carousel }}
        swiperSettings={{
          slidesPerView: 'auto',
          spaceBetween: 24,
        }}
      >
        {cards?.map((slide, index) => (
          <CarouselSlide key={index} className={styles.carouselSlide}>
            <div key={`offer-card-${index}`} className={styles.cardWrapper}>
              {slide}
            </div>
          </CarouselSlide>
        ))}
      </Carousel>
      <CarouselControls>
        <CarouselPagination
          name={carouselId}
          customClassNames={styles.customPagination}
        />
        <CarouselNavigation
          name={carouselId}
          ariaLabels={{
            previous: 'Go to previous slide',
            next: 'Go to next slide',
          }}
        />
      </CarouselControls>
    </section>
  )
}
